import React, { Component } from 'react';
import queryString from 'query-string';
import './App.css';
import Loading from './Loading';

import Draft from './Draft';
import Create from './Create';

const HOST = "";

const sortChampions = (a, b) => {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }

  return 0;
};

class App extends Component {
  constructor(props) {
    super(props);

    const parsed = queryString.parse(location.search);
    this.state = {draftId: parsed.draft, auth: parsed.auth, locale: parsed.locale};
  }
  componentDidMount() {
    fetch(`/champions/${this.state.locale || 'en_US'}`)
      .then(res => res.json())
      .then(json => this.setState({
        version: json.version,
        champions: Object.keys(json.data).map(key => json.data[key]).sort(sortChampions)
      }));
  }
  render() {
    return (
      this.state.draftId
        ? this.state.champions ? <Draft host={HOST} draft={this.state.draftId} auth={this.state.auth} champions={this.state.champions} version={this.state.version} /> : <Loading />
        : <Create host={HOST} />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js